module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "notice-item"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.createTime))]), _vm._v(" "), _c('div', {
      staticClass: "notice-content pd-25"
    }, [_c('div', {
      staticClass: "fs-34 color-333 font-bold"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "mt-15 fs-28 color-999"
    }, [_vm._v("\n                        " + _vm._s(item.content) + "\n                    ")])])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d82afaca","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/My/messageList.vue
// module id = oISC
// module chunks = 51